import { z } from 'zod';

// Defaults let `vite build` succeed even when `.env.production` is absent
// (the file is gitignored — local prod builds + CI without explicit overrides
// shouldn't crash at module load with "Required"). Deploy pipelines override
// VITE_API_URL via shell env vars at build time for the real upstream.
const EnvSchema = z.object({
  VITE_API_URL: z.string().url().default('http://localhost:4000'),
  VITE_APP_NAME: z.string().min(1).default('Sarraf'),
});

export type ClientEnv = z.infer<typeof EnvSchema>;

const parsed = EnvSchema.safeParse(import.meta.env);

if (!parsed.success) {
  const issues = parsed.error.issues
    .map((i) => `  - ${i.path.join('.') || '(root)'}: ${i.message}`)
    .join('\n');
  throw new Error(`Invalid client env:\n${issues}`);
}

export const env: ClientEnv = parsed.data;
